import { useEffect, useRef, useState } from "react";
import styles from "./styles/PosTicketSearch.module.css";
import InputText from "../../../components/ui/input_text/InputText";
import Button from "../../../components/ui/button/Button";
import { useTranslation } from "react-i18next";
import { ReactComponent as QrCode } from "../../../assets/qr_schweers.svg";
import { ReactComponent as Ban } from "../../../assets/ban.svg";
import { ReactComponent as Check } from "../../../assets/check.svg";
/**
 * Scan QR code component
 */
const PosScanTickets = ({
    setShowScan, // {Function} - Function to set the visibility of the scan modal
    submitData, // {Function} - Function to submit the scanned data
}) => {
    const [scanCode, setScanCode] = useState({ scanValue: "" });
    const [scanResult, setScanResult] = useState({
        success: false,
        failed: false,
    });

    const { t } = useTranslation();
    const scanRef = useRef();

    // Set focus on the text input used for scanning code result once the setShowScan function is excuted,
    // and reset the value and hide the module after 10 seconds
    useEffect(() => {
        scanRef.current && scanRef.current.focus();
        const timer = setTimeout(() => {
            setScanCode({ scanValue: "" });
            setShowScan(false);
        }, 10000);

        return () => clearTimeout(timer);
    }, [setShowScan]);

    /**
     * Input handler function
     * Store the scan result in scanCode state
     * Excute extractData function after the code input is finished
     * @param {Event} event - The event object
     */
    const handleInput = (event) => {
        const value = event.target.value;
        setScanCode({ scanValue: value.trim() });
        if (value.endsWith("\n") || value.endsWith("\r")) {
            // Automatically process the input when the scanner sends the "Enter" key
            extractData(value.trim());
        }
    };
    /**
     * Submit handle function
     *
     * @param {Event} event - The event object
     */
    const handleSubmit = (event) => {
        event.preventDefault();
        extractData(scanCode?.scanValue);
    };

    /**
     * Refocus the input element
     */
    const handleBlur = () => {
        // Refocus the input if the value is empty
        if (!scanCode?.scanValue) {
            scanRef.current.focus();
        }
    };

    /**
     * Extracting the data from the scanner result and submitting if data is valid.
     * QR code example:
     * http://localhost:3000/PolitessPaymentTesting/?ticketNumber=DZ660808&licensePlate=HKN3067
     * Extracting the data:
     * 1- split the string on the "?" symbol and use the second part.
     * 2- split the second part on the "&" symbol.
     * 3- create key value object by splitting each of the parts on the "=" symbol
     * and use the part before the "=" as the key and the one after it as the value.
     * The extracted date is validated after the extraction,
     * and then if valid, a filter expression is creaed using that data.
     * The filter expression is used to fetch data afterword.
     * If not valid or no scanresult ahow feed back
     * @param {String} scannedData - The result from the scanner
     */
    function extractData(scannedData) {
        if (!scannedData) return;
        let isValid = false;
        let parsedParams = {};

        if (scannedData.includes("?")) {
            const params = scannedData.split("?")[1].split("&"); // splitting the scan resulton "?" and take the second part and split it on "&"
            parsedParams = params.reduce((acc, pair) => {
                const [key, value] = pair.split("=");
                acc[key] = value;
                return acc;
            }, {}); // split the strings on "=" and asign key and value pairs

            const expectedKeys = ["ticketNumber", "licensePlate"];

            // Validate the result to the expectedKeys
            const parsedKeys = Object.keys(parsedParams); //get the keys
            isValid =
                expectedKeys.every((key) => parsedKeys.includes(key)) &&
                parsedKeys.length === expectedKeys.length; // check if the keys are the same as the expectedKeys
        }

        if (isValid) {
            // Construct the filter expression
            const expression = `Ticketno == \"${parsedParams?.ticketNumber}\" || Plate == \"${parsedParams?.licensePlate}\"`;
            setScanResult({ success: true, failed: false });
            setTimeout(() => {
                submitData(expression);
            }, 2000);
        } else {
            setScanCode({ scanValue: "" });
            setScanResult({ success: false, failed: true });
            setTimeout(() => {
                setShowScan(false);
            }, 2000);
        }
    }

    return (
        <section className={`${styles.scan_form_back}  flex-container`}>
            <div className={`${styles.main_form_container} v-flex-container`}>
                <div
                    className={`${styles.form_header_container} flex-container`}
                >
                    <h1 className={`${styles.form_header}`}>
                        {t(`scan QRcode`)}
                    </h1>
                </div>
                <form
                    className={`${styles.form_container} v-flex-container`}
                    onSubmit={handleSubmit}
                    noValidate={true} // Disable default HTML5 validation
                >
                    <div
                        className={`${styles.qr_main_container} flex-container`}
                    >
                        <div
                            className={`${styles.ban_symbol}  ${
                                scanResult?.failed ? styles.show_symbol : ""
                            }`}
                        >
                            {/* The not allowed image */}
                            <Ban fill="red" width="13rem" />
                        </div>
                        <div
                            className={`${styles.check_symbol} ${
                                scanResult?.success ? styles.show_symbol : ""
                            }`}
                        >
                            {/* The success image */}
                            <Check fill="green" width="13rem" />
                        </div>
                        <div
                            className={`${styles.qr_container} flex-container`}
                        >
                            <div
                                className={`${styles.qrcode}  ${
                                    scanResult?.success || scanResult?.failed
                                        ? styles.fade_qrcode
                                        : ""
                                } flex-container`}
                            >
                                {/* The QR code image */}
                                <QrCode fill="#202020" width="15rem" />
                            </div>

                            <div
                                className={`${styles.scanner_bar}  ${
                                    scanResult?.success || scanResult?.failed
                                        ? styles.hide_bar
                                        : ""
                                }`}
                            ></div>
                        </div>
                    </div>

                    <div className={`${styles.scan_input}`}>
                        <InputText
                            ref={scanRef}
                            handleBlur={handleBlur}
                            inputId={"scanValue"}
                            inputValue={scanCode?.scanValue}
                            handleChangeFunction={handleInput}
                        />
                    </div>

                    <div
                        className={`${styles.form_button_container} flex-container`}
                    >
                        <Button
                            body={t(`close`)}
                            type={"button"}
                            onClickFuction={() => setShowScan(false)}
                        />
                    </div>
                </form>
            </div>
        </section>
    );
};

export default PosScanTickets;
